const darkModePreference = window.matchMedia("(prefers-color-scheme: dark)");

const getDeviceScheme = () => darkModePreference.matches ? 'dark' : 'light';

const getUserScheme = () => localStorage.getItem('color-scheme')

const getColorScheme = () => getUserScheme() ?? getDeviceScheme();

const updateScheme = () => {
  document.body.classList.remove('scheme-light', 'scheme-dark');
  document.body.classList.add(`scheme-${getColorScheme()}`);
}

const toggleScheme = () => {
  const newScheme = getColorScheme() === 'light' ? 'dark' : 'light';
  localStorage.setItem('color-scheme', newScheme);
  updateScheme();
}

const clearUserColorScheme = () => localStorage.removeItem('color-scheme');

updateScheme();

darkModePreference.addEventListener("change", () => {
  clearUserColorScheme();
  updateScheme();
});

const toggleButton = document.querySelector('#extras-color-scheme-toggle');
toggleButton?.addEventListener('click', toggleScheme)
